import { useQuery } from '@tanstack/react-query';

import { fetchAssetById } from '../services/svp';

const defaultParams = { additional: 'metadata' };

export const useAsset = (assetId?: number) => {
  return useQuery({
    queryKey: ['asset', assetId],
    queryFn: () => fetchAssetById(assetId!, defaultParams),
    enabled: Boolean(assetId),
  });
};
